import { Component, OnInit, OnDestroy, Directive } from '@angular/core';
import { Subscription } from 'rxjs';

/**
 * General base for useful things
 *
 * @export
 * @class BaseComponentComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Directive({
  selector: 'lib-base-component'
})
export class BaseComponentComponent implements OnInit, OnDestroy {

  /**
   * Array of subscriptions from child classes
   *
   * @type {Array<Subscription>}
   * @memberof BaseComponentComponent
   */
  subscriptions:Array<Subscription> = [];
  constructor() { }

  ngOnInit() {
  }

  /**
   * Add ngOnDestroy for unsubscribe
   *
   * @memberof BaseComponentComponent
   */
  ngOnDestroy(): void {
    this.subscriptions.forEach(value=> value.unsubscribe())
  }
}
